import { encode } from 'querystring';

import { handlePartialUpload } from '../../Utils/Upload.jsx';
import { API_ENDPOINTS } from '../../common.js';

export function ManageUploadFile(
    participation,
    setSendingParticipationState,
    sendingParticipationState,
    setContinueEnabled,
    changerPage,
    updateParticipation,
) {

   const sendRecordParticipationMedia= async (typeMedia) => {
        if (participation.id || participation.task_id || sendingParticipationState === 'sended') {
            return;
        }
        updateParticipation();
        // Check mandatory
        //let withError = await checkMandatoryFields();
        //if (withError)
        //    return;

        // Save exxtraUserInformation if asked or delete them
        // Sauvegarder les extraUserInformation si souhaitée sinon les supprimer
        //saveRemeberMe();
        const mediaBlob = typeMedia === 'video' ? participation.video.blob: participation.image.file;
        setSendingParticipationState('sending');
        setContinueEnabled(false);
        const extension = typeMedia === 'video' ? 'webm': participation.image.extension;
        const filename = typeMedia === 'video' ? 'recording.webm' : `image.${participation.image.extension}`;
        const contentType = typeMedia === 'video' ? 'video/wave' : `image/${participation.image.extension}`;
        console.log(filename);
        const file = new File([mediaBlob], filename, { type: `${typeMedia}/${extension}` });
        // Initialize upload (get url storage)
        const { data_id, url } = await fetch(API_ENDPOINTS.upload, {
            method: 'POST',
            body: JSON.stringify({ extension }),
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Server respond with error !");
            }
            else {
                return response.json();
            }
        });
        // Processed to upload using previous storage url
        await handlePartialUpload(file, url);
        // Gestion des données dans le cas d'un témoinage
        let content = {}
        if (participation.voteValue) {
            content = participation.voteValue;
        }
        if (participation.textAnswer) {
            content.text = participation.textAnswer;
        }
        // Create intreaction
        const query = {
            channel_id: participation.channel_id,
            segment: participation.segment,
            language: participation.language,
            device_id: participation.device_id,
            data_id,
            extension
        };
        console.log(contentType);
        // PUT method is for voice recording
        const data = await fetch(API_ENDPOINTS.interactions + `?${encode(query)}`,
            {
                method: "PUT",
                headers: {
                    'Content-Disposition': `form-data; name="file"; filename="${filename}"`,
                    'Content-Type': contentType,
                    'Extra-User-Information': JSON.stringify(participation.extra_user_information),
                    'Collect-Content': JSON.stringify(content),
                }
            }).then(response => {
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Server respond with error !");
                }
                else {
                    return response.json();
                }
            });
        participation.id = data.id;
        await setSendingParticipationState('sended');
        await changerPage();
        return data;
    };

    const sendRecordParticipationImage = async () => {
        await sendRecordParticipationMedia('image');
    }
    const sendRecordParticipationVideo = async () => {
        await sendRecordParticipationMedia('video');
    }
 
    return {
        sendRecordParticipationVideo,
        sendRecordParticipationImage
    };
}